/**
 * @fileoverview POST handler for the "/engagement/segments/:app_group_id/update_tags" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsUpdateTagsCacheKeys } from "./constants";
import type { SegmentsUpdateTagsParams, SegmentsUpdateTagsResult } from "./types";

export const engagementSegmentsUpdateTags = reactQueryMutationAdapter(
  engagementSegmentsUpdateTagsCacheKeys,
  ({
    app_group_id,
    desired_state,
    undo_identifier,
  }: SegmentsUpdateTagsParams): Promise<SegmentsUpdateTagsResult> => {
    // manipulate props here as needed {  }

    return fetch(`/engagement/segments/${app_group_id}/update_tags`, "POST", {
      desired_state,
      undo_identifier,
    });
  }
);
